module.exports = __webpack_public_path__ + "img/Sort Icon - charcoal.a5345a60.svg";